import { Tool } from "@/types/content";
import { Brain, Calculator, Heart, Moon, Scale, Sparkles, Stars, Wand2 } from "lucide-react";

export const tools: Tool[] = [
  {
    title: "Twin Flame Compatibility Quiz",
    description: "Discover your compatibility level and areas for growth",
    icon: Heart,
    link: "/tools/compatibility-quiz",
  },
  {
    title: "Stage Identifier",
    description: "Identify your current twin flame journey stage",
    icon: Scale,
    link: "/tools/stage-identifier",
  },
  {
    title: "Life Path Calculator",
    description: "Calculate your life path number and its significance",
    icon: Calculator,
    link: "/tools/life-path-calculator",
  },
  {
    title: "Past Life Connection",
    description: "Explore potential past life connections",
    icon: Stars,
    link: "/tools/past-life",
  },
  {
    title: "Telepathy Assessment",
    description: "Evaluate your telepathic connection strength",
    icon: Brain,
    link: "/tools/telepathy",
  },
  {
    title: "Dream Interpretation",
    description: "Understand the meaning behind your twin flame dreams",
    icon: Moon,
    link: "/tools/dream-interpretation",
  },
  {
    title: "Reunion Readiness",
    description: "Assess your readiness for twin flame reunion",
    icon: Sparkles,
    link: "/tools/reunion-readiness",
  },
  {
    title: "Manifestation Readiness",
    description: "Evaluate your manifestation preparation",
    icon: Wand2,
    link: "/tools/manifestation",
  },
];